import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import SchoolsTable from '../../components/schools/SchoolsTable';

const SchoolsArchive = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <SchoolsTable isArchive />
        </WrapperSection>
    );
};

export default SchoolsArchive;
